import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./TeacherCoursesUIHelpers";

const TeacherCoursesUIContext = createContext();

export function useTeacherCoursesUIContext() {
  return useContext(TeacherCoursesUIContext);
}

export const TeacherCoursesUIConsumer = TeacherCoursesUIContext.Consumer;

export function TeacherCoursesUIProvider({ teacherCoursesUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewSectionPage: teacherCoursesUIEvents.openNewSectionPage
  };

  return (
    <TeacherCoursesUIContext.Provider value={value}>
      {children}
    </TeacherCoursesUIContext.Provider>
  );
}